import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MODERATED_MESSAGE_TEXT, Message } from 'src/app/dto';

// The single renderer for a message's body text, used by every message surface (chat popup,
// mailbox conversation, message board). A partially or fully blocked message shows only the
// moderation placeholder; the original text the server sends with a partially blocked one is
// never displayed.
@Component({
    selector: 'app-message-body',
    templateUrl: './message-body.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageBodyComponent {
    message = input.required<Message>();
    protected readonly moderatedText = MODERATED_MESSAGE_TEXT;
}
